import type { ReactNode } from 'react';
import { useVisibility } from '@/hooks/useVisibility';

interface AdminOnlyProps {
  fallback?: ReactNode;
  children: ReactNode;
}

/** Renders children only for users who can see company financials. */
export function AdminOnly({ fallback = null, children }: AdminOnlyProps) {
  const { canSeeCompanyFinancials } = useVisibility();
  return <>{canSeeCompanyFinancials ? children : fallback}</>;
}
